import {Component, OnInit} from "@angular/core";
import {LoggerService} from "../common/logger.service";
import {UserService} from "../common/user.service";
import {UsanaObject} from "../usana-object";
import {AuthenticationService} from "./authentication.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Constants} from "../constants";
import {take} from "rxjs/operators";
import {LoginModalService} from "../login/login-modal.service";
import {IShopUser} from "../session/customer-models";
import {Util} from "../util/util";
import {environment} from "../../../environments/environment";


@Component({
    selector: 'logout',
    template: '',
    standalone: false
})
export class LogoutComponent extends UsanaObject implements OnInit {

    constructor(
        private loggerService: LoggerService,
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private loginModalService: LoginModalService,
        private router: Router,
        private route: ActivatedRoute
    ) {
        super(loggerService);
    }

    ngOnInit() {
        this.userService.getShopUser().subscribe({
            next: (user: IShopUser) => this.logout(user)
        });
    }

    private logout(user: IShopUser) {
        this.authenticationService.logout().subscribe({
            next: () => this.continueLogout(user),
            error: (error) => {
                this.log.error(error);
                this.continueLogout(user);
            }
        });
    }

    private continueLogout(user: IShopUser) {
        if (JSON.parse(this.route.snapshot.queryParamMap.get('goToLogin'))) {
            this.loginModalService.openLogin().pipe(take(1)).subscribe();
        } else if (user.country === Constants.COUNTRY_CN) { // do not use currentCountry
            Util.redirect(`${environment.BAOYING_URL}${Constants.URL_HUB}`, false);
        } else { //on logout go to landing
            this.router.navigate([Constants.RELOAD_STATE]);
        }
    }
}
